import React from 'react'
import { useSlate } from 'slate-react'
import { toggleBlock } from 'modules/community/hooks/slate-editor-utils'
import { isBlockActive } from 'modules/community/utils/editor/core'

export default function BlockButton({
  format,
  label,
  children,
}: React.PropsWithChildren<{
  format: string
  label: string
}>) {
  const editor = useSlate()
  const active = isBlockActive(editor, format)
  return (
    <button
      className={`relative z-10 inline-flex items-center px-2 py-1 ${
        active ? 'fill-black' : 'fill-text-secondary hover:fill-black'
      } `}
      onMouseDown={event => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
      title={label}
      type="button"
    >
      {children}
    </button>
  )
}
